module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "table_container",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    staticClass: "tree_data lineheighttree",
    attrs: {
      "data": _vm.menudata,
      "show-checkbox": "",
      "node-key": "uk",
      "expand-on-click-node": false,
      "props": _vm.defaultProps,
      "default-checked-keys": _vm.alreadyChoose
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.saveSeting()
      }
    }
  }, [_vm._v("保存")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_desc_contianer title"
  }, [_c('div', {
    staticClass: "table_container role_type"
  }, [_vm._v("开放城市")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7793c9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/opencity.vue
// module id = 1731
// module chunks = 3